import React, { FC } from 'react'

import { IconShoppingTrolleyProps } from './IconShoppingTrolley.types'
import * as Styled from './styles/IconShoppingTrolley.style'

import { nonThemeableRules } from '../../ruleSet'

const IconShoppingTrolley: FC<IconShoppingTrolleyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconShoppingTrolleyProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconShoppingTrolleyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M72 120a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0 24a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm48-24a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0 24a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm39.23-118.36A4 4 0 0 0 156 24H38.17L33.8 10.75A4 4 0 0 0 30 8H4a4 4 0 0 0 0 8h23.11l4.31 13.09q0 .16.11.32l23.67 71.84A4 4 0 0 0 59 104h74a4 4 0 0 0 3.81-2.78l23-72a4 4 0 0 0-.58-3.58zM130.08 96H61.89L40.8 32h109.72z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconShoppingTrolley
